import { useState } from "react";

import type { IFilterObject } from "@/lib/centra/useProductFilter/filterFormatter";

import Filter from "../../Filter/Filter";
import styles from "./filterGroup.module.scss";

interface UIProps {
  filterGroup: {
    name: string;
    filters: IFilterObject[];
  };
  open: boolean;
}

const UI = ({ filterGroup, open }: UIProps) => {
  const [active, setActive] = useState(open);

  const activeFilters =
    filterGroup.filters.filter((filter) => filter.active).length || 0;

  return (
    <div className={`${styles.container} ${active ? styles.open : ""}`}>
      <h3 className={styles.label} onClick={() => setActive(!active)}>
        {filterGroup.name}
        {activeFilters > 0 && <span>({activeFilters})</span>}
      </h3>
      {active && (
        <div className={styles.filters}>
          {filterGroup.filters.map((filter) => (
            <Filter
              filter={filter}
              key={`${filterGroup.name}-${filter.value}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default UI;
